import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage =
    'Hola, me interesa la propuesta Prudence × TNO Network (Inbound Marketing: planes Esencial 120€, Desarrollo 220€ o Premium 350€/mes, con 2do Escalón).';

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom align="center">
          ¿Listo para activar Placer Inteligente, Decisiones Seguras?
        </Typography>
        <Typography align="center" color="textSecondary" variant="h6" sx={{ maxWidth: 560, mx: 'auto' }}>
          Conectemos Prudence con la audiencia joven de 2do Escalón en TNO Network.
        </Typography>
      </Box>
      <Box maxWidth={480} margin="0 auto">
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={2} justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            sx={{ height: 54 }}
            onClick={() =>
              window.open(`https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`, '_blank')
            }
          >
            Solicitar propuesta Prudence
          </Button>
          <Button
            href="https://www.tnonetwork.com"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ height: 54 }}
            fullWidth
          >
            Conocer TNO Network
          </Button>
        </Box>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Prudence × TNO Media Lab 888 · The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
